export default __webpack_public_path__ + "static/media/308.4eb07aec.svg";